import { resourceKeys } from '@aimmo/ui';
import { api, assertOk } from '../lib/api.js';
import { makeLookup } from '../lib/lookup.js';

/**
 * The contact picker, shared by the contact form's own self-references today
 * and by every mandate, demand and appointment form from M4 on.
 *
 * A typed search rather than a loaded list, for the same reason as the comune
 * picker: an agency's contact table is the largest thing in the database. A
 * reference to a contact the user cannot see reads as unknown rather than
 * crashing the form.
 */
export const { search: searchContacts, resolve: resolveContact } = makeLookup({
  key: resourceKeys.all('contacts'),
  search: async (query, signal) =>
    assertOk(
      await api.contacts.list({
        query: { page: 1, pageSize: 20, order: 'asc', ...(query ? { q: query } : {}) },
        fetchOptions: { signal },
      }),
    ).body.items,
  get: async (id, signal) =>
    assertOk(await api.contacts.get({ params: { id }, fetchOptions: { signal } })).body,
  toOption: (contact) => ({ value: contact.id, label: contact.displayName }),
});
